//var ajaxAddress = 'https://panel.ddoor.online/api/public/api/'
const getBaseUrl = () => {
  let url
  switch (process.env.NODE_ENV) {
    case 'production':
      url = 'https://panel.ddoor.online/api/public/api/'
      break
    case 'development':
    default:
      url = 'http://localhost/mydekingwood/api/public/api/'
  }

  return url
}
var ajaxAddress = 'http://localhost/mydekingwood/api/public/api/'
//const storageUrl = 'https://panel.deckingwoodco.com/api/public/api/'
ajaxAddress = getBaseUrl()
export default ajaxAddress
